import { Linkedin } from 'lucide-react';

interface CandidateFact {
  label: string;
  value: string;
}

interface CandidateFactsProps {
  facts: CandidateFact[];
  linkedInUrl: string | null;
}

/** The left column: a hairline definition list and the LinkedIn link. */
export function CandidateFacts({ facts, linkedInUrl }: CandidateFactsProps) {
  return (
    <aside className="flex flex-col gap-5 lg:sticky lg:top-6 lg:self-start">
      {facts.length > 0 && (
        <dl className="divide-border flex flex-col divide-y border-y text-[13px]">
          {facts.map((fact) => (
            <div
              className="flex items-start justify-between gap-4 py-2.5"
              key={fact.label}
            >
              <dt className="text-neutral-500">{fact.label}</dt>
              <dd className="text-right font-medium tabular-nums">
                {fact.value}
              </dd>
            </div>
          ))}
        </dl>
      )}
      {linkedInUrl && (
        <a
          className="text-primary-700 inline-flex items-center gap-2 text-[13px] font-medium hover:underline"
          href={linkedInUrl}
          rel="noopener noreferrer"
          target="_blank"
        >
          <Linkedin aria-hidden className="size-3.5" />
          LinkedIn profile
        </a>
      )}
    </aside>
  );
}
